// extracted by mini-css-extract-plugin
export default {"tablecss":"styles_tablecss__9UP0V"};